/**
 *  Importer Module
 */

angular
  .module('importer', ['ngResource', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.importer.all(), {
        controller: 'ImporterCtrl',
        templateUrl: '/r/static/templates/importer/all.html',
      })
      .when(CONFIG.url.importer.importer(), {
        controller: 'ImporterDoimportCtrl',
        templateUrl: '/r/static/templates/importer/import.html',
      })
  }])
  .factory('Importer', ['$resource', function ($resource) {
    var Importer = $resource(
      CONFIG.api('importer'),
      {},
      {
        query: {method: 'POST', isArray: false, params: {id: 'all'}},
        importer: {method: 'POST', isArray: false, params: {id: 'importer'}},
        get_sheet_metadata: {method: 'POST', isArray: false, params: {id: 'get_sheet_metadata'}},
        mark_undone: {method: 'POST', isArray: false, params: {id: 'mark_undone'}},
      },
    )
    return Importer
  }])

/* Controllers */

angular.module('importer').controller('ImporterCtrl', ['$scope', 'Importer', 'Member', '$rootScope', '$modal', '$route', function ($scope, Importer, Member, $rootScope, $modal, $route) {
  $scope.utils.setPageTitle(_('breadcrumb_members'))
  $scope.utils.setPageID('members')

  $scope.paginate = function (page) {
    $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
  }

  $scope.undo_modal = function (id, log_batch_id) {
    $scope.undo_id = id
    $scope.undo_log_batch_id = log_batch_id
    $modal({
      template: '/r/static/templates/partials/modal.html',
      persist: true,
      show: true,
      backdrop: 'static',
      scope: $scope,
    })
  }

  $scope.import_undo = function () {
    // Mark the import as having an undo in progress
    $.each($scope.imports, function (k, v) {
      if (v.id == $scope.undo_id) {
        v.undoing = true
      }
    })

    Member.bulkremove(
      {
        filter: [{field: 'id', value: $scope.undo_log_batch_id, verb: 'a4fromlogbatch'}],
      },
      // success handler
      function (data) {
        Importer.mark_undone(
          {
            id: $scope.undo_id,
          },
          // success handler
          function (data) {
            $scope.notify.set($scope, _('HTML_import_import_undone'))
            $route.reload()
          },
          // error handler
          a4.restErrorFactory($scope),
        )
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }

  Importer.query(
    {
      id: 'all',
    },
    // success handler
    function (data) {
      $scope.imports = data.imports

      // pagination
      $scope.pageSize = 10
      $scope.numberOfPages = Math.ceil($scope.imports.length / $scope.pageSize)
      $scope.currentPage = 0

      $scope.modal = {
        header: _('import_undo_modal_header'),
        content: _('import_undo_modal_content'),
        confirmation_btn: _('import_undo_import'),
        callback: $scope.import_undo,
      }

      a4.loaded($scope)
    },
    // error handler
    a4.restErrorFactory($scope),
  )
}])

angular
  .module('importer')
  .controller('ImporterDoimportCtrl', ['$scope', '$rootScope', '$location', '$routeParams', 'Importer', 'Field', 'Group', function ($scope, $rootScope, $location, $routeParams, Importer, Field, Group) {
    $scope.utils.setPageTitle(_('breadcrumb_members'))
    $scope.utils.setPageID('members')

    $rootScope.importInProgress = true

    // Step 1, get the current fields to display to the user
    $scope.imports = Importer.query({id: 'all', count_only: true}, function () {})

    $scope.fieldHash = {}

    $scope.fields = Field.query(
      {id: 'all'},
      function () {
        a4.loaded($scope)

        // Make a hash so we can print the field labels from the name later
        for (var i = 0; i < $scope.fields.length; i++) {
          $scope.fieldHash[$scope.fields[i].name] = $scope.fields[i].label
        }

        // Add group labels
        var _currentHeading
        angular.forEach($scope.fields, function (v, k) {
          // Set the current heading, if this is a heading
          if (v.type == 'heading') {
            _currentHeading = v.label
          }

          if (_currentHeading && !v.group) {
            v.group = _currentHeading
          } else if (!v.group) {
            v.group = _('field_group_basic')
          }
        })

        // debug aids
        if ($location.search()['debug_step3']) {
          $scope.step = 3
          $scope.upload_success({id: parseInt($location.search()['debug_step3'], 10)})
        }
      },
      a4.restErrorFactory($scope),
    )

    $scope.groups = Group.query(
      {id: 'all'},
      function () {
        angular.forEach($scope.groups, function (v, k) {
          $scope.fieldHash[v.name] = v.label
          v.group = _('field_group_groups')
        })
      },
      a4.restErrorFactory($scope),
    )

    $scope.$watch('groups+fields', function () {
      if ($scope.groups && $scope.fields) {
        $scope.fields_and_groups = $scope.fields.concat($scope.groups)
      }
    })

    $scope.step = 1

    $scope.filterHeadings = function (item) {
      return item.type !== 'heading'
    }

    // Callbacks for step 2
    $scope.upload_failure = function (data, window) {
      $scope.errors = data.error.general
      $scope._sending = false
    }

    $scope.upload_success = function (data, window) {
      $scope.importer_id = data.id
      // Reset the file upload form to be able to re-send the same file.
      $('#file_upload_form')[0].reset()

      // Add _ignore "do not import" field for mapping
      if ($scope.fields[0].name !== '_ignore') {
        $scope.fields.unshift({
          name: '_ignore',
          label: _('import_field_ignore'),
        })
      }

      // Step 3, call get_sheet_metadata()
      Importer.get_sheet_metadata(
        {
          id: $scope.importer_id,
        },
        function (data) {
          $scope._sending = false

          $scope.src_cols = data.src_cols
          $scope.data_rows = data.data_rows
          $scope.filename = data.filename
          $scope.step = 3

          // Build mapping data to display
          if ($scope.srcDataChanged()) {
            $scope.mapping = []

            $.each($scope.src_cols, function (k, v) {
              $scope.mapping.push({
                src_col: v.index,
                dst_field: v.dst_field,
              })
            })
          }
        },
        a4.restErrorFactory($scope),
      )
    }

    $scope.srcDataChanged = function () {
      var ret

      var _currentStr = $.map($scope.src_cols, function (e) {
        return e.title
      }).join('')

      if ((!$scope.srcDataCheck && $scope.mapping) || $scope.srcDataCheck === _currentStr) {
        ret = false
      } else {
        ret = true
      }

      $scope.srcDataCheck = _currentStr
      return ret
    }

    $scope.isMappingIncomplete = function () {
      if (!$scope.mapping) {
        return true
      }

      // Check the mapping data and make sure there are no duplicates or empty fields
      for (var i = 0; i < $scope.mapping.length; i++) {
        if ($scope.mapping[i].duplicate || !$scope.mapping[i].dst_field) {
          return true
        }
      }
      return false
    }

    $scope.mappingChanged = function () {
      for (var i = 0; i < $scope.mapping.length; i++) {
        // Reset the notification
        $scope.mapping[i].duplicate = false

        // Check all the mappings against this mapping for a duplicate
        for (var y = 0; y < $scope.mapping.length; y++) {
          if (
            $scope.mapping[i].dst_field === $scope.mapping[y].dst_field &&
            i !== y &&
            $scope.mapping[i].dst_field &&
            $scope.mapping[i].dst_field !== '_ignore'
          ) {
            $scope.mapping[i].duplicate = true
          }
        }
      }
    }

    $scope.do_import = function () {
      $scope._sending = true

      var trimmed_mapping = []

      // Remove any ignored mapping data before posting
      for (var i = 0; i < $scope.mapping.length; i++) {
        if ($scope.mapping[i].dst_field !== '_ignore') {
          trimmed_mapping.push($scope.mapping[i])
        }
      }

      Importer.importer(
        {
          id: $scope.importer_id,
          mapping: trimmed_mapping,
        },
        function (data) {
          $scope._sending = false

          $scope.step = 4
          if (data.errors) {
            $scope.errors = data.errors
            $scope.showPhoneHint = data.errors.some(function (row) {
              return row.errors && row.errors.phone
            })
          } else {
            // Redirect to member list view with a notification
            // data.batch_id is available here too if we should need it
            $scope.notify.set($scope, _('HTML_import_import_done', {_n: data.count, url: CONFIG.url.importer.all()}))
            $location.path(CONFIG.url.members.all())
          }
        },
        a4.restErrorFactory($scope),
      )
    }

    // Called from clicking 'upload again' or 'Back'
    $scope.step_back = function (steps) {
      $scope.step -= steps || 1
      $scope.errors = null
    }

    // Script to trigger automatic file upload after file selection
    // NB: This might be run multiple times if there are more included files
    // That's why we use .onchange instead of jQuery .change()

    $scope.$on('$includeContentLoaded', function () {
      if ($('input[id="thefile"]').length > 0) {
        $('input[id="thefile"]').get(0).onchange = function () {
          $scope._sending = true
          $('#file_upload_form').submit()
        }
      }
    })
  }])
